import { useDispatch } from "react-redux";
import TextInput from "../../../../components/TextInputs";
import { APP_ICONS } from "../../../../assets";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import GlobalButton from "../../../../components/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import CustomRangePicker from "../../../../components/DateRangePicker";
import { setInventoryMovementEndDate, setInventoryMovementName, setInventoryMovementStartDate, setInventoryMovementType, setInventoryMovementVendorId } from "../../../../lib/slices/searchKeysSlice";
import { useSelector } from "react-redux";
import { MenuItem, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomSelect from "../../../../components/customSelect";
import { setInventoryCurrentPage } from "../../../../lib/slices/pagination/inventoryPageSlice";
import { INVENTORY_MOVEMENT_REASON } from "../../../../constants/Variables";
import { getAllSupplier } from "../../../../services/supplierApiFn";
import { handleOpenSnackBar } from "../../../../utils";


export const InventoryFilters = ({ fetchData }) => {
    // dispatch actions
    const dispatch = useDispatch();

    // Tracking state
    const { t } = useTranslation(["products", "common"]);

    // Search keys
    const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);

    // Get current language
    const { currentLanguage } = useSelector((state) => state.languageReducer);

    // Get pagination data
    const pagination = useSelector((state) => state.inventoryPaginationReducer);

    const [allSuppliers, setAllSuppliers] = useState([]);

    const fetchAllSuppliers = async () => {
        try {
            const response = await getAllSupplier("");
            if (response.data.status === "success") {
                setAllSuppliers(response.data.data.suppliers);
            } else {
                handleOpenSnackBar("error", response.data.message);
            }
        } catch (error) {
            handleOpenSnackBar("error", error.message);
        }
    };

    useEffect(() => {
        fetchAllSuppliers();
    }, []);

    return (
        <Stack
            p={2}
            direction={{ xs: "column", md: "row" }}
            alignItems={"stretch"}
            gap={1.25}
            bgcolor={"primary.light"}
            flexWrap="wrap"
        >
            <TextInput
                styleProps={{
                    width: { xs: "100%", md: "22%", xl: "20%" },
                    "& .MuiOutlinedInput-root": {
                        height: 42,
                    },
                }}
                InputStartIcon={<img src={APP_ICONS.searchGreyIcon} width={25} />}
                InputEndIcon={
                    searchKeys.inventoryMovementName && (
                        <CancelOutlinedIcon
                            fontSize="small"
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                                dispatch(setInventoryMovementName(""));
                            }}
                        />
                    )
                }
                placeholder={t("searchBySku")}
                value={searchKeys.inventoryMovementName}
                onChange={(e) => {
                    dispatch(setInventoryMovementName(e.target.value));
                }}
            />
            <CustomSelect
                placeholder={t("suppliers", { ns: "common" })}
                formStyleProps={{
                    width: { xs: "100%", md: "20%", xl: "18%" },
                    "& .MuiInputBase-input": {
                        textTransform: "capitalize",
                    },
                    "& .MuiOutlinedInput-root": {
                        height: 42,
                    },
                }}
                value={searchKeys.inventoryMovementVendorId || "all"}
                onChange={(e) => {
                    dispatch(setInventoryCurrentPage(1));
                    dispatch(setInventoryMovementVendorId(e.target.value));
                }}
            >
                <MenuItem value="all">{t("all", { ns: "common" })}</MenuItem>
                {allSuppliers.map((val, ind) => (
                    <MenuItem
                        key={ind}
                        value={val._id}
                        sx={{ textTransform: "capitalize" }}
                    >
                        {val.businessName}
                    </MenuItem>
                ))}
            </CustomSelect>
            <CustomSelect
                placeholder={t("reason", { ns: "common" })}
                formStyleProps={{
                    width: { xs: "100%", md: "20%", xl: "18%" },
                    "& .MuiInputBase-input": {
                        textTransform: "capitalize",
                    },
                    "& .MuiOutlinedInput-root": {
                        height: 42,
                    },
                }}
                value={searchKeys.inventoryMovementType}
                onChange={(e) => {
                    dispatch(setInventoryCurrentPage(1));
                    dispatch(setInventoryMovementType(e.target.value));
                }}
            >
                <MenuItem value={"All"}>{t("all", { ns: "common" })}</MenuItem>
                {INVENTORY_MOVEMENT_REASON.map((val, ind) => (
                    <MenuItem
                        key={ind}
                        value={val.value}
                        sx={{ textTransform: "capitalize" }}
                    >
                        {val.label[currentLanguage]}
                    </MenuItem>
                ))}
            </CustomSelect>

            <Stack
                direction={"row"}
                alignItems={"stretch"}
                sx={{
                    width: { xs: "100%", md: "34%", xl: "40%" },
                    minWidth: 0,
                    flexGrow: 1,
                }}
            >
                <CustomRangePicker
                    startDate={searchKeys.inventoryMovementStartDate}
                    setStartDate={(value) => {
                        // dispatch(setUserPlanCurrentPage(1));
                        dispatch(setInventoryMovementStartDate(value));
                    }}
                    endDate={searchKeys.inventoryMovementEndDate}
                    setEndDate={(value) => {
                        // dispatch(setUserPlanCurrentPage(1));
                        dispatch(setInventoryMovementEndDate(value));
                    }}
                    stackProps={{
                        flex: 1,
                        minWidth: 0,
                        height: 42,
                        px: 1.25,
                        borderRadius: "6px 0px 0px 6px",
                        border: "1px solid #dddddd",
                    }}
                    rangeProps={{
                        displayFormat: "DD MMM YYYY",
                    }}
                />
                <GlobalButton
                    endIcon={<SearchIcon />}
                    handleClickBtn={() => {
                        dispatch(setInventoryCurrentPage(1));
                        
                        fetchData?.(
                            searchKeys.inventoryMovementName,
                            searchKeys.inventoryMovementType,
                            pagination.page,
                            pagination.limit,
                            searchKeys.inventoryMovementStartDate,
                            searchKeys.inventoryMovementEndDate,
                            searchKeys.inventoryMovementVendorId,
                        );
                    }}
                    styleProps={{
                        color: "primary",
                        width: "auto",
                        borderRadius: "0px 6px 6px 0px",
                        minWidth: 45,
                        height: "42px",
                        "& .MuiButton-icon": {
                            marginLeft: "0px",
                        },
                    }}
                />
            </Stack>
        </Stack>
    );
};